<div class="pointCF__field">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField?.label }}"
    [ppTrimTooltip]="true"
  >
    @switch (volyIntegrationActive) {
      @case (EIntegrationStatus.OFF) {
        <img
          class="pointCF__bulk-changes-field-icon"
          [src]="EIconPath.CUSTOM_FIELD_LIST_ACTIVITY"
        />
      }

      @case (EIntegrationStatus.ON) {
        <img
          class="pointCF__bulk-changes-field-icon"
          [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL"
        />
      }

      @case (EIntegrationStatus.DISABLED) {
        <img
          class="pointCF__bulk-changes-field-icon"
          [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL"
        />
      }
    }

    <span class="pointCF__label-container"> {{ ppCustomField?.label }} </span>
  </label>

  <div class="pointCF__content">
    <div>
      <button
        type="button"
        [attr.aria-label]="'Select ' + ppCustomField?.label"
        data-test="bulkListFieldInput"
        id="{{ 'bulkclist' + ppFieldId }}"
        [class.pointCF__input--disabled]="disabled"
        class="pointCF__input pointCF__input--list"
        (click)="showList('bulkclist' + ppFieldId, ppCustomField)"
        ppTooltip
        [ppTitle]="ppCustomField.lockedValue ? ('locked_by_admin' | ppTranslate) : ''"
      >
        @if (ppCustomFieldsExtended[ppFieldId]?.value) {
          <span
            ppTooltip
            [ppTrimTooltip]="true"
            [ppTitle]="ppCustomFieldsExtended[ppFieldId].value"
            class="pointCF__list-cf-text"
            >{{ ppCustomFieldsExtended[ppFieldId].value }}</span
          >
        }

        @if (!ppCustomFieldsExtended[ppFieldId]?.value) {
          <span class="placeholder-text">{{ 'select...' | ppTranslate }}</span>
        }
      </button>
    </div>

    @if (!ppCustomField.lockedValue) {
      <button class="pointCF__clear" (click)="clearCustomField(ppCustomField)">&#xd7;</button>

      <i class="fa fa-caret-down pointCF__dropdown-icon" aria-hidden="true"></i>
    } @else {
      <div class="pointCF__padlock">
        <pp-padlock-icon />
      </div>
    }
  </div>
</div>
